import { ShopperSocialGroupJoinInputPage } from "./../pages/shopper-social-group-join-input/shopper-social-group-join-input";
// import { LoginQrPage } from "./../pages/login-qr/login-qr";
// import { ManualMerchantPage } from "./../pages/manual-merchant/manual-merchant";
// import { ManaulShopperPage } from "./../pages/manaul-shopper/manaul-shopper";
// import { ManaulPage } from "./../pages/manaul/manaul";
import { ViewHeader2Page } from "./../pages/view-header2/view-header2";
// import { MerchantYourShopPage } from "./../pages/merchant-your-shop/merchant-your-shop";
import { MerchantStatMissionPage } from "./../pages/merchant-stat-mission/merchant-stat-mission";
import { PlazaStatMissionPage } from "./../pages/plaza-stat-mission/plaza-stat-mission";
// import { ShopperBuySocialPayScanConfirmPage } from "./../pages/shopper-buy-social-pay-scan-confirm/shopper-buy-social-pay-scan-confirm";
// import { ShopperBuyProductMerchantlistPage } from "./../pages/shopper-buy-product-merchantlist/shopper-buy-product-merchantlist";
// import { ShopperMissionSocialDescPage } from "./../pages/shopper-mission-social-desc/shopper-mission-social-desc";
// import { ShopperBuyProductPayScanConfirmPage } from "./../pages/shopper-buy-product-pay-scan_confirm/shopper-buy-product-pay-scan_confirm";
// import { ShopperVotePlazaPage } from "./../pages/shopper-vote-plaza/shopper-vote-plaza";
// import { ShopperBuySocialPayPage } from "./../pages/shopper-buy-social-pay/shopper-buy-social-pay";
// import { ShopperBuyProductPayScanPage } from "./../pages/shopper-buy-product-pay-scan/shopper-buy-product-pay-scan";
// import { ShopperBuyProductPayPage } from "./../pages/shopper-buy-product-pay/shopper-buy-product-pay";
// import { ShopperBuySocialPage } from "./../pages/shopper-buy-social/shopper-buy-social";
// import { ShopperSocialGroupJoinScanPage } from "./../pages/shopper-social-group-join-scan/shopper-social-group-join-scan";
// import { ShopperSocialGroupCreateShopPage } from "./../pages/shopper-social-group-create-shop/shopper-social-group-create-shop";
// import { ShopperSocialGroupJoinPage } from "./../pages/shopper-social-group-join/shopper-social-group-join";
// import { ShopperSocialGroupCreatePage } from "./../pages/shopper-social-group-create/shopper-social-group-create";
// import { ShopperMissionShoppingPage } from "./../pages/shopper-mission-shopping/shopper-mission-shopping";
// import { ShopperVotePage } from "./../pages/shopper-vote/shopper-vote";
// import { ShopperOverviewPlazamapPage } from "./../pages/shopper-overview-plazamap/shopper-overview-plazamap";
// import { ShopperOverviewMovementPage } from "./../pages/shopper-overview-movement/shopper-overview-movement";
// import { ShopperOverviewPlazaPage } from "./../pages/shopper-overview-plaza/shopper-overview-plaza";
// import { ShopperOverviewCashPage } from "./../pages/shopper-overview-cash/shopper-overview-cash";
import { ShopperResultPage } from "./../pages/shopper-result/shopper-result";
// import { ShopperShoppingBagPage } from "./../pages/shopper-shopping-bag/shopper-shopping-bag";
// import { ShopperBuySocialPlazalistPage } from "./../pages/shopper-buy-social-plazalist/shopper-buy-social-plazalist";
// import { ShopperBuyProductPlazalistPage } from "./../pages/shopper-buy-product-plazalist/shopper-buy-product-plazalist";
// import { ShopperSocialGroupPage } from "./../pages/shopper-social-group/shopper-social-group";
// import { ShopperMissionPage } from "./../pages/shopper-mission/shopper-mission";
// import { ShopperOverviewPage } from "./../pages/shopper-overview/shopper-overview";
// import { MerchantShopPayRentalConfirmPage } from "./../pages/merchant-shop-pay-rental-confirm/merchant-shop-pay-rental-confirm";
// import { PlazaCollectFeePage } from "./../pages/plaza-collect-fee/plaza-collect-fee";
// import { MerchantShopPayRentalPage } from "./../pages/merchant-shop-pay-rental/merchant-shop-pay-rental";
// import { MerchantShopMenuPage } from "./../pages/merchant-shop-menu/merchant-shop-menu";
import { MerchantStatShopPage } from "./../pages/merchant-stat-shop/merchant-stat-shop";
import { MerchantStatShopperPage } from "./../pages/merchant-stat-shopper/merchant-stat-shopper";
// import { MerchantProfitPage } from "./../pages/merchant-profit/merchant-profit";
// import { MerchantCashflowPage } from "./../pages/merchant-cashflow/merchant-cashflow";
// import { MerchantResultPage } from "./../pages/merchant-result/merchant-result";
// import { MerchantRentalRentComfirmPage } from "./../pages/merchant-rental-rent-comfirm/merchant-rental-rent-comfirm";
// import { MerchantRentalRentPage } from "./../pages/merchant-rental-rent/merchant-rental-rent";
// import { MerchantRentalYourspacePage } from "./../pages/merchant-rental-yourspace/merchant-rental-yourspace";
import { ShopperRequrementPage } from "./../pages/shopper-requrement/shopper-requrement";
import { PlazaStatShopperPage } from "./../pages/plaza-stat-shopper/plaza-stat-shopper";
import { PlazaStatMerchantPage } from "./../pages/plaza-stat-merchant/plaza-stat-merchant";
// import { MerchantOverviewPlazamapPage } from "./../pages/merchant-overview-plazamap/merchant-overview-plazamap";
// import { MerchantOverviewPlazaPage } from "./../pages/merchant-overview-plaza/merchant-overview-plaza";
// import { MerchantRentalPage } from "./../pages/merchant-rental/merchant-rental";
// import { MerchantOverviewStockPage } from "./../pages/merchant-overview-stock/merchant-overview-stock";
// import { MerchantMissionPage } from "./../pages/merchant-mission/merchant-mission";
// import { MerchantOverviewMovementPage } from "./../pages/merchant-overview-movement/merchant-overview-movement";
// import { MerchantOverviewCashPage } from "./../pages/merchant-overview-cash/merchant-overview-cash";
// import { MerchantOverviewPage } from "./../pages/merchant-overview/merchant-overview";
import { ViewHeaderPage } from "./../pages/view-header/view-header";
import { WaitStep3Page } from "./../pages/wait-step3/wait-step3";
import { QuizResultPage } from "./../pages/quiz-result/quiz-result";
import { QuizTestPage } from "./../pages/quiz-test/quiz-test";
import { QuizPage } from "./../pages/quiz/quiz";
import { WaitStep2Page } from "./../pages/wait-step2/wait-step2";

// import { PlazaResultPage } from "./../pages/plaza-result/plaza-result";
import { PlazaStatSubPage } from "./../pages/plaza-stat-sub/plaza-stat-sub";
// import { PlazaThemeChangeSavePage } from "./../pages/plaza-theme-change-save/plaza-theme-change-save";
// import { PlazaTicketPage } from "./../pages/plaza-ticket/plaza-ticket";
// import { PlazaTicketSocialPage } from "./../pages/plaza-ticket-social/plaza-ticket-social";
// import { PlazaScanPayPage } from "./../pages/plaza-scan-pay/plaza-scan-pay";
// import { PlazaSelectThemeSavePage } from "./../pages/plaza-select-theme-save/plaza-select-theme-save";
import { PlazaStatPage } from "./../pages/plaza-stat/plaza-stat";
// import { PlazaProfitPage } from "./../pages/plaza-profit/plaza-profit";
// import { PlazaCashflowPage } from "./../pages/plaza-cashflow/plaza-cashflow";
// import { PlazaSelectThemePage } from "./../pages/plaza-select-theme/plaza-select-theme";
import { PlazaSelectPlanRentPage } from "./../pages/plaza-select-plan-rent/plaza-select-plan-rent";
import { PlazaSelectPlanInvestPage } from "./../pages/plaza-select-plan-invest/plaza-select-plan-invest";
// import { PlazaSelectPlanChoosePage } from "./../pages/plaza-select-plan-choose/plaza-select-plan-choose";
// import { PlazaSelectPlanPage } from "./../pages/plaza-select-plan/plaza-select-plan";
// import { PlazaOverviewPlazamapPage } from "./../pages/plaza-overview-plazamap/plaza-overview-plazamap";
// import { PlazaOverviewMovementPage } from "./../pages/plaza-overview-movement/plaza-overview-movement";
// import { PlazaOverviewCashPage } from "./../pages/plaza-overview-cash/plaza-overview-cash";
// import { PlazaMissionPage } from "./../pages/plaza-mission/plaza-mission";
// import { PlazaOverviewPage } from "./../pages/plaza-overview/plaza-overview";
// import { PlazaSelectTeamPage } from "./../pages/plaza-select-team/plaza-select-team";

// import { MerchantHomePage } from "./../pages/merchant-home/merchant-home";
// import { MerchantSelectTeamPage } from "./../pages/merchant-select-team/merchant-select-team";

// import { ShopperHomePage } from "./../pages/shopper-home/shopper-home";
// import { ShopperSelectTeamPage } from "./../pages/shopper-select-team/shopper-select-team";

import { BrowserModule } from "@angular/platform-browser";
import { ErrorHandler, NgModule, Injectable } from "@angular/core";
import { IonicApp, IonicErrorHandler, IonicModule } from "ionic-angular";
import { SplashScreen } from "@ionic-native/splash-screen";
import { StatusBar } from "@ionic-native/status-bar";
import { QRScanner } from "@ionic-native/qr-scanner";
import { ServiceProvider } from "../providers/service/service";
import { IonicStorageModule } from "@ionic/storage";
import { HttpModule } from "@angular/http";
import { TranslateModule, TranslateLoader } from "@ngx-translate/core";
import {
  HttpClientModule,
  HttpClient,
  HttpHeaders,
} from "@angular/common/http";
// import { TranslateHttpLoader } from "@ngx-translate/http-loader";
// import { ProgressBarComponent } from "../components/progress-bar/progress-bar";

import { MyApp } from "./app.component";
import { SelectLanguagePage } from "./../pages/select-language/select-language";
// import { LoginPage } from "./../pages/login/login";
import { HomePage } from "../pages/home/home";
import { SelectSearchableModule } from "ionic-select-searchable";
import { NgxQRCodeModule } from "ngx-qrcode2";
import { QrresultPage } from "./../pages/qrresult/qrresult";
// import { PlazaThemeChangePage } from "../pages/plaza-theme-change/plaza-theme-change";
import { Ng2GoogleChartsModule } from "ng2-google-charts";
// import { MerchantShopRefillStockPage } from "../pages/merchant-shop-refill-stock/merchant-shop-refill-stock";
import { PlazaCollectFeeConfirmPage } from "../pages/plaza-collect-fee-confirm/plaza-collect-fee-confirm";
// import { ShopperMissionSocialPage } from "../pages/shopper-mission-social/shopper-mission-social";
// import { ShopperMissionOutstandingPage } from "../pages/shopper-mission-outstanding/shopper-mission-outstanding";
// import { ShopperSocialGroupCreateShopNewPage } from "../pages/shopper-social-group-create-shop-new/shopper-social-group-create-shop-new";
// import { ShopperSocialGroupJoinScanConfirmPage } from "../pages/shopper-social-group-join-scan-confirm/shopper-social-group-join-scan-confirm";
import { ShopperBuyProductPage } from "../pages/shopper-buy-product/shopper-buy-product";
// import { ShopperBuySocialPayScanPage } from "../pages/shopper-buy-social-pay-scan/shopper-buy-social-pay-scan";
import { NativeAudio } from "@ionic-native/native-audio";
// import { StreamingMedia } from "@ionic-native/streaming-media";
import { Observable } from "rxjs/Observable";
import { catchError } from "rxjs/operators";
// import { LoginSyncPlatformPage } from "../pages/login-sync-platform/login-sync-platform";
// import { LoginSyncPlatformRegisterPage } from "../pages/login-sync-platform-register/login-sync-platform-register";

import { InAppBrowser } from "@ionic-native/in-app-browser";
import { PlazaSlotThemePage } from "../pages/plaza-slot-theme/plaza-slot-theme";
import { ShopperBuyProductPayInputPage } from "../pages/shopper-buy-product-pay-input/shopper-buy-product-pay-input";
import { ShopperBuySocialPayInputPage } from "../pages/shopper-buy-social-pay-input/shopper-buy-social-pay-input";
import { MerchantRentalRentInputPage } from "../pages/merchant-rental-rent-input/merchant-rental-rent-input";
import { MerchantShopPayRentalInputPage } from "../pages/merchant-shop-pay-rental-input/merchant-shop-pay-rental-input";
import { ComponentsModule } from "../components/components.module";
import { LoginPageModule } from "../pages/login/login.module";

// import { SelectLanguagePageModule } from "../pages/select-language/select-language.module";
import { LoginSyncPlatformPageModule } from "../pages/login-sync-platform/login-sync-platform.module";
import { LoginSyncPlatformRegisterPageModule } from "../pages/login-sync-platform-register/login-sync-platform-register.module";
// import { WaitStep2PageModule } from "../pages/wait-step2/wait-step2.module";
// import { QrresultPageModule } from "../pages/qrresult/qrresult.module";
// import { QuizPageModule } from "../pages/quiz/quiz.module";
// import { QuizTestPageModule } from "../pages/quiz-test/quiz-test.module";
// import { ShopperRequrementPageModule } from "../pages/shopper-requrement/shopper-requrement.module";
import { ShopperHomePageModule } from "../pages/shopper-home/shopper-home.module";
// import { QuizResultPageModule } from "../pages/quiz-result/quiz-result.module";
// import { WaitStep3PageModule } from "../pages/wait-step3/wait-step3.module";
// import { ViewHeaderPageModule } from "../pages/view-header/view-header.module";
import { PlazaSelectTeamPageModule } from "../pages/plaza-select-team/plaza-select-team.module";
import { PlazaOverviewPageModule } from "../pages/plaza-overview/plaza-overview.module";
import { PlazaMissionPageModule } from "../pages/plaza-mission/plaza-mission.module";
import { PlazaOverviewCashPageModule } from "../pages/plaza-overview-cash/plaza-overview-cash.module";
import { PlazaOverviewMovementPageModule } from "../pages/plaza-overview-movement/plaza-overview-movement.module";
import { PlazaOverviewPlazamapPageModule } from "../pages/plaza-overview-plazamap/plaza-overview-plazamap.module";
import { PlazaSelectPlanPageModule } from "../pages/plaza-select-plan/plaza-select-plan.module";
import { PlazaSelectPlanChoosePageModule } from "../pages/plaza-select-plan-choose/plaza-select-plan-choose.module";
// import { PlazaSelectPlanInvestPageModule } from "../pages/plaza-select-plan-invest/plaza-select-plan-invest.module";
// import { PlazaSelectPlanRentPageModule } from "../pages/plaza-select-plan-rent/plaza-select-plan-rent.module";
import { PlazaSelectThemePageModule } from "../pages/plaza-select-theme/plaza-select-theme.module";
import { PlazaProfitPageModule } from "../pages/plaza-profit/plaza-profit.module";
import { PlazaCashflowPageModule } from "../pages/plaza-cashflow/plaza-cashflow.module";
// import { PlazaStatPageModule } from "../pages/plaza-stat/plaza-stat.module";
import { PlazaSelectThemeSavePageModule } from "../pages/plaza-select-theme-save/plaza-select-theme-save.module";
import { PlazaScanPayPageModule } from "../pages/plaza-scan-pay/plaza-scan-pay.module";
import { PlazaTicketPageModule } from "../pages/plaza-ticket/plaza-ticket.module";
import { PlazaTicketSocialPageModule } from "../pages/plaza-ticket-social/plaza-ticket-social.module";
import { PlazaCollectFeePageModule } from "../pages/plaza-collect-fee/plaza-collect-fee.module";
// import { PlazaCollectFeeConfirmPageModule } from "../pages/plaza-collect-fee-confirm/plaza-collect-fee-confirm.module";
import { PlazaThemeChangePageModule } from "../pages/plaza-theme-change/plaza-theme-change.module";
import { PlazaThemeChangeSavePageModule } from "../pages/plaza-theme-change-save/plaza-theme-change-save.module";
// import { PlazaStatMerchantPageModule } from "../pages/plaza-stat-merchant/plaza-stat-merchant.module";
// import { PlazaStatShopperPageModule } from "../pages/plaza-stat-shopper/plaza-stat-shopper.module";
// import { PlazaStatSubPageModule } from "../pages/plaza-stat-sub/plaza-stat-sub.module";
import { PlazaResultPageModule } from "../pages/plaza-result/plaza-result.module";
// import { PlazaStatMissionPageModule } from "../pages/plaza-stat-mission/plaza-stat-mission.module";
import { MerchantSelectTeamPageModule } from "../pages/merchant-select-team/merchant-select-team.module";
import { MerchantHomePageModule } from "../pages/merchant-home/merchant-home.module";
import { MerchantOverviewPageModule } from "../pages/merchant-overview/merchant-overview.module";
import { MerchantOverviewCashPageModule } from "../pages/merchant-overview-cash/merchant-overview-cash.module";
import { MerchantOverviewMovementPageModule } from "../pages/merchant-overview-movement/merchant-overview-movement.module";
import { MerchantOverviewStockPageModule } from "../pages/merchant-overview-stock/merchant-overview-stock.module";
import { MerchantOverviewPlazaPageModule } from "../pages/merchant-overview-plaza/merchant-overview-plaza.module";
import { MerchantOverviewPlazamapPageModule } from "../pages/merchant-overview-plazamap/merchant-overview-plazamap.module";
import { MerchantMissionPageModule } from "../pages/merchant-mission/merchant-mission.module";
import { MerchantRentalPageModule } from "../pages/merchant-rental/merchant-rental.module";
import { MerchantRentalRentPageModule } from "../pages/merchant-rental-rent/merchant-rental-rent.module";
import { MerchantRentalRentComfirmPageModule } from "../pages/merchant-rental-rent-comfirm/merchant-rental-rent-comfirm.module";
import { MerchantRentalYourspacePageModule } from "../pages/merchant-rental-yourspace/merchant-rental-yourspace.module";
import { MerchantResultPageModule } from "../pages/merchant-result/merchant-result.module";
// import { MerchantStatShopperPageModule } from "../pages/merchant-stat-shopper/merchant-stat-shopper.module";
import { MerchantCashflowPageModule } from "../pages/merchant-cashflow/merchant-cashflow.module";
import { MerchantProfitPageModule } from "../pages/merchant-profit/merchant-profit.module";
// import { MerchantStatShopPageModule } from "../pages/merchant-stat-shop/merchant-stat-shop.module";
import { MerchantShopMenuPageModule } from "../pages/merchant-shop-menu/merchant-shop-menu.module";
import { MerchantShopRefillStockPageModule } from "../pages/merchant-shop-refill-stock/merchant-shop-refill-stock.module";
import { MerchantShopPayRentalPageModule } from "../pages/merchant-shop-pay-rental/merchant-shop-pay-rental.module";
import { MerchantShopPayRentalConfirmPageModule } from "../pages/merchant-shop-pay-rental-confirm/merchant-shop-pay-rental-confirm.module";
// import { MerchantStatMissionPageModule } from "../pages/merchant-stat-mission/merchant-stat-mission.module";
import { ShopperSelectTeamPageModule } from "../pages/shopper-select-team/shopper-select-team.module";
import { ShopperBuyProductPlazalistPageModule } from "../pages/shopper-buy-product-plazalist/shopper-buy-product-plazalist.module";
// import { ShopperBuyProductMerchantlistPageModule } from "../pages/shopper-buy-product-merchantlist/shopper-buy-product-merchantlist.module";
// import { ShopperBuyProductPageModule } from "../pages/shopper-buy-product/shopper-buy-product.module";
import { ShopperBuyProductPayPageModule } from "../pages/shopper-buy-product-pay/shopper-buy-product-pay.module";
import { ShopperBuyProductPayScanPageModule } from "../pages/shopper-buy-product-pay-scan/shopper-buy-product-pay-scan.module";
import { ShopperBuyProductPayScanConfirmPageModule } from "../pages/shopper-buy-product-pay-scan_confirm/shopper-buy-product-pay-scan_confirm.module";
import { ShopperBuySocialPlazalistPageModule } from "../pages/shopper-buy-social-plazalist/shopper-buy-social-plazalist.module";
import { ShopperBuySocialPayPageModule } from "../pages/shopper-buy-social-pay/shopper-buy-social-pay.module";
import { ShopperBuySocialPayScanPageModule } from "../pages/shopper-buy-social-pay-scan/shopper-buy-social-pay-scan.module";
import { ShopperBuySocialPayScanConfirmPageModule } from "../pages/shopper-buy-social-pay-scan-confirm/shopper-buy-social-pay-scan-confirm.module";
import { ShopperBuySocialPageModule } from "../pages/shopper-buy-social/shopper-buy-social.module";
import { ShopperShoppingBagPageModule } from "../pages/shopper-shopping-bag/shopper-shopping-bag.module";
// import { ShopperResultPageModule } from "../pages/shopper-result/shopper-result.module";
import { ShopperOverviewPageModule } from "../pages/shopper-overview/shopper-overview.module";
import { ShopperOverviewCashPageModule } from "../pages/shopper-overview-cash/shopper-overview-cash.module";
import { ShopperOverviewPlazaPageModule } from "../pages/shopper-overview-plaza/shopper-overview-plaza.module";
import { ShopperOverviewPlazamapPageModule } from "../pages/shopper-overview-plazamap/shopper-overview-plazamap.module";
import { ShopperOverviewMovementPageModule } from "../pages/shopper-overview-movement/shopper-overview-movement.module";
import { ShopperMissionPageModule } from "../pages/shopper-mission/shopper-mission.module";
import { ShopperMissionSocialPageModule } from "../pages/shopper-mission-social/shopper-mission-social.module";
import { ShopperMissionSocialDescPageModule } from "../pages/shopper-mission-social-desc/shopper-mission-social-desc.module";
import { ShopperMissionShoppingPageModule } from "../pages/shopper-mission-shopping/shopper-mission-shopping.module";
import { ShopperMissionOutstandingPageModule } from "../pages/shopper-mission-outstanding/shopper-mission-outstanding.module";
import { ShopperSocialGroupPageModule } from "../pages/shopper-social-group/shopper-social-group.module";
import { ShopperSocialGroupCreatePageModule } from "../pages/shopper-social-group-create/shopper-social-group-create.module";
import { ShopperSocialGroupCreateShopPageModule } from "../pages/shopper-social-group-create-shop/shopper-social-group-create-shop.module";
import { ShopperSocialGroupCreateShopNewPageModule } from "../pages/shopper-social-group-create-shop-new/shopper-social-group-create-shop-new.module";
import { ShopperSocialGroupJoinPageModule } from "../pages/shopper-social-group-join/shopper-social-group-join.module";
import { ShopperSocialGroupJoinScanPageModule } from "../pages/shopper-social-group-join-scan/shopper-social-group-join-scan.module";
// import { ShopperSocialGroupJoinInputPageModule } from "../pages/shopper-social-group-join-input/shopper-social-group-join-input.module";
import { ShopperSocialGroupJoinScanConfirmPageModule } from "../pages/shopper-social-group-join-scan-confirm/shopper-social-group-join-scan-confirm.module";
import { ShopperVotePlazaPageModule } from "../pages/shopper-vote-plaza/shopper-vote-plaza.module";
import { ShopperVotePageModule } from "../pages/shopper-vote/shopper-vote.module";
import { MerchantYourShopPageModule } from "../pages/merchant-your-shop/merchant-your-shop.module";
// import { ViewHeader2PageModule } from "../pages/view-header2/view-header2.module";
import { ManaulPageModule } from "../pages/manaul/manaul.module";
import { ManaulShopperPageModule } from "../pages/manaul-shopper/manaul-shopper.module";
import { ManualMerchantPageModule } from "../pages/manual-merchant/manual-merchant.module";
import { VideoTutorialModalPageModule } from "../pages/video-tutorial-modal/video-tutorial-modal.module";
import { DiscountListPage } from "../pages/discount-list/discount-list";
// import { PlazaSlotThemePageModule } from "../pages/plaza-slot-theme/plaza-slot-theme.module";
// import { ShopperBuyProductPayInputPageModule } from "../pages/shopper-buy-product-pay-input/shopper-buy-product-pay-input.module";
// import { ShopperBuySocialPayInputPageModule } from "../pages/shopper-buy-social-pay-input/shopper-buy-social-pay-input.module";
// import { MerchantRentalRentInputPageModule } from "../pages/merchant-rental-rent-input/merchant-rental-rent-input.module";
// import { MerchantShopPayRentalInputPageModule } from "../pages/merchant-shop-pay-rental-input/merchant-shop-pay-rental-input.module";

// export function setTranslateLoader(http: HttpClient) {
//   return new TranslateHttpLoader(http, 'https://theplaza-v2.ingenious-simulation.com/v1/translations?token=02ab88616c5bbdd5bbcbe82ca0a300e917570d3e&language=', '');
//   // return new TranslateHttpLoader(http, '/assets/i18n/', '.json');
// }

@Injectable()
export class CustomTranslateLoader implements TranslateLoader {
  contentHeader = new HttpHeaders({
    Accept: "application/json",
  });

  constructor(private httpClient: HttpClient) {}
  getTranslation(lang: string): Observable<any> {
    const apiAddress =
      "https://theplaza-v2.ingenious-simulation.com/v1/translations?token=02ab88616c5bbdd5bbcbe82ca0a300e917570d3e&language=" +
      lang;
    return this.httpClient
      .get(apiAddress, { headers: this.contentHeader })
      .pipe(catchError((_) => this.httpClient.get("/assets/i18n/en-US.json")));
  }
}

@NgModule({
  declarations: [
    MyApp,
    // ProgressBarComponent,
    SelectLanguagePage,
    // LoginPage,
    // LoginSyncPlatformPage,
    // LoginSyncPlatformRegisterPage,
    WaitStep2Page,
    QrresultPage,
    QuizPage,
    QuizTestPage,
    ShopperRequrementPage,
    HomePage,
    // ShopperHomePage,
    QuizResultPage,
    WaitStep3Page,
    ViewHeaderPage,
    // PlazaSelectTeamPage,
    // PlazaOverviewPage,
    // PlazaMissionPage,
    // PlazaOverviewCashPage,
    // PlazaOverviewMovementPage,
    // PlazaOverviewPlazamapPage,
    // PlazaSelectPlanPage,
    // PlazaSelectPlanChoosePage,
    PlazaSelectPlanInvestPage,
    PlazaSelectPlanRentPage,
    // PlazaSelectThemePage,
    // PlazaProfitPage,
    // PlazaCashflowPage,
    PlazaStatPage,
    // PlazaSelectThemeSavePage,
    // PlazaScanPayPage,
    // PlazaTicketPage,
    // PlazaTicketSocialPage,
    // PlazaCollectFeePage,
    PlazaCollectFeeConfirmPage,
    // PlazaThemeChangePage,
    // PlazaThemeChangeSavePage,
    PlazaStatMerchantPage,
    PlazaStatShopperPage,
    PlazaStatSubPage,
    // PlazaResultPage,
    PlazaStatMissionPage,
    // MerchantSelectTeamPage,
    // MerchantHomePage,
    // MerchantOverviewPage,
    // MerchantOverviewCashPage,
    // MerchantOverviewMovementPage,
    // MerchantOverviewStockPage,
    // MerchantOverviewPlazaPage,
    // MerchantOverviewPlazamapPage,
    // MerchantMissionPage,
    // MerchantRentalPage,
    // MerchantRentalRentPage,
    // MerchantRentalRentComfirmPage,
    // MerchantRentalYourspacePage,
    // MerchantResultPage,
    MerchantStatShopperPage,
    // MerchantCashflowPage,
    // MerchantProfitPage,
    MerchantStatShopPage,
    // MerchantShopMenuPage,
    // MerchantShopRefillStockPage,
    // MerchantShopPayRentalPage,
    // MerchantShopPayRentalConfirmPage,
    MerchantStatMissionPage,
    // ShopperSelectTeamPage,
    // ShopperBuyProductPlazalistPage,
    // ShopperBuyProductMerchantlistPage,
    ShopperBuyProductPage,
    // ShopperBuyProductPayPage,
    // ShopperBuyProductPayScanPage,
    // ShopperBuyProductPayScanConfirmPage,
    // ShopperBuySocialPlazalistPage,
    // ShopperBuySocialPayPage,
    // ShopperBuySocialPayScanPage,
    // ShopperBuySocialPayScanConfirmPage,
    // ShopperBuySocialPage,
    // ShopperShoppingBagPage,
    ShopperResultPage,
    // ShopperOverviewPage,
    // ShopperOverviewCashPage,
    // ShopperOverviewPlazaPage,
    // ShopperOverviewPlazamapPage,
    // ShopperOverviewMovementPage,
    // ShopperMissionPage,
    // ShopperMissionSocialPage,
    // ShopperMissionSocialDescPage,
    // ShopperMissionShoppingPage,
    // ShopperMissionOutstandingPage,
    // ShopperSocialGroupPage,
    // ShopperSocialGroupCreatePage,
    // ShopperSocialGroupCreateShopPage,
    // ShopperSocialGroupCreateShopNewPage,
    // ShopperSocialGroupJoinPage,
    // ShopperSocialGroupJoinScanPage,
    ShopperSocialGroupJoinInputPage,
    // ShopperSocialGroupJoinScanConfirmPage,
    // ShopperVotePlazaPage,
    // ShopperVotePage,
    // MerchantYourShopPage,
    ViewHeader2Page,
    // ManaulPage,
    // ManaulShopperPage,
    // ManualMerchantPage,
    // LoginQrPage,
    PlazaSlotThemePage,

    ShopperBuyProductPayInputPage,
    ShopperBuySocialPayInputPage,
    MerchantRentalRentInputPage,
    MerchantShopPayRentalInputPage,
    DiscountListPage,
  ],
  imports: [
    BrowserModule,
    HttpModule,
    HttpClientModule,
    SelectSearchableModule,
    NgxQRCodeModule,
    Ng2GoogleChartsModule,
    ComponentsModule,
    IonicModule.forRoot(MyApp, {
      // backButtonText: 'กลับ'
    }),
    IonicStorageModule.forRoot({}),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        // useFactory: (setTranslateLoader),
        useClass: CustomTranslateLoader,
        deps: [HttpClient],
      },
    }),
    LoginPageModule,
    // SelectLanguagePageModule,
    LoginSyncPlatformPageModule,
    LoginSyncPlatformRegisterPageModule,
    // WaitStep2PageModule,
    // QrresultPageModule,
    // QuizPageModule,
    // QuizTestPageModule,
    // ShopperRequrementPageModule,
    ShopperHomePageModule,
    // QuizResultPageModule,
    // WaitStep3PageModule,
    // ViewHeaderPageModule,
    PlazaSelectTeamPageModule,
    PlazaOverviewPageModule,
    PlazaMissionPageModule,
    PlazaOverviewCashPageModule,
    PlazaOverviewMovementPageModule,
    PlazaOverviewPlazamapPageModule,
    PlazaSelectPlanPageModule,
    PlazaSelectPlanChoosePageModule,
    // PlazaSelectPlanInvestPageModule,
    // PlazaSelectPlanRentPageModule,
    PlazaSelectThemePageModule,
    PlazaProfitPageModule,
    PlazaCashflowPageModule,
    // PlazaStatPageModule,
    PlazaSelectThemeSavePageModule,
    PlazaScanPayPageModule,
    PlazaTicketPageModule,
    PlazaTicketSocialPageModule,
    PlazaCollectFeePageModule,
    // PlazaCollectFeeConfirmPageModule,
    PlazaThemeChangePageModule,
    PlazaThemeChangeSavePageModule,
    // PlazaStatMerchantPageModule,
    // PlazaStatShopperPageModule,
    // PlazaStatSubPageModule,
    PlazaResultPageModule,
    // PlazaStatMissionPageModule,
    MerchantSelectTeamPageModule,
    MerchantHomePageModule,
    MerchantOverviewPageModule,
    MerchantOverviewCashPageModule,
    MerchantOverviewMovementPageModule,
    MerchantOverviewStockPageModule,
    MerchantOverviewPlazaPageModule,
    MerchantOverviewPlazamapPageModule,
    MerchantMissionPageModule,
    MerchantRentalPageModule,
    MerchantRentalRentPageModule,
    MerchantRentalRentComfirmPageModule,
    MerchantRentalYourspacePageModule,
    MerchantResultPageModule,
    // MerchantStatShopperPageModule,
    MerchantCashflowPageModule,
    MerchantProfitPageModule,
    // MerchantStatShopPageModule,
    MerchantShopMenuPageModule,
    MerchantShopRefillStockPageModule,
    MerchantShopPayRentalPageModule,
    MerchantShopPayRentalConfirmPageModule,
    // MerchantStatMissionPageModule,
    ShopperSelectTeamPageModule,
    ShopperBuyProductPlazalistPageModule,
    // ShopperBuyProductMerchantlistPageModule,
    // ShopperBuyProductPageModule,
    ShopperBuyProductPayPageModule,
    ShopperBuyProductPayScanPageModule,
    ShopperBuyProductPayScanConfirmPageModule,
    ShopperBuySocialPlazalistPageModule,
    ShopperBuySocialPayPageModule,
    ShopperBuySocialPayScanPageModule,
    ShopperBuySocialPayScanConfirmPageModule,
    ShopperBuySocialPageModule,
    ShopperShoppingBagPageModule,
    // ShopperResultPageModule,
    ShopperOverviewPageModule,
    ShopperOverviewCashPageModule,
    ShopperOverviewPlazaPageModule,
    ShopperOverviewPlazamapPageModule,
    ShopperOverviewMovementPageModule,
    ShopperMissionPageModule,
    ShopperMissionSocialPageModule,
    ShopperMissionSocialDescPageModule,
    ShopperMissionShoppingPageModule,
    ShopperMissionOutstandingPageModule,
    ShopperSocialGroupPageModule,
    ShopperSocialGroupCreatePageModule,
    ShopperSocialGroupCreateShopPageModule,
    ShopperSocialGroupCreateShopNewPageModule,
    ShopperSocialGroupJoinPageModule,
    ShopperSocialGroupJoinScanPageModule,
    // ShopperSocialGroupJoinInputPageModule,
    ShopperSocialGroupJoinScanConfirmPageModule,
    ShopperVotePlazaPageModule,
    ShopperVotePageModule,
    MerchantYourShopPageModule,
    // ViewHeader2PageModule,
    ManaulPageModule,
    ManaulShopperPageModule,
    ManualMerchantPageModule,
    // // LoginQrPage,
    // PlazaSlotThemePageModule,

    // ShopperBuyProductPayInputPageModule,
    // ShopperBuySocialPayInputPageModule,
    // MerchantRentalRentInputPageModule,
    // MerchantShopPayRentalInputPageModule,
    VideoTutorialModalPageModule,
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    SelectLanguagePage,
    // LoginPage,
    // LoginSyncPlatformPage,
    // LoginSyncPlatformRegisterPage,
    QrresultPage,
    WaitStep2Page,
    QuizPage,
    QuizTestPage,
    // ShopperHomePage,
    QuizResultPage,
    WaitStep3Page,
    ViewHeaderPage,
    ShopperRequrementPage,
    HomePage,
    // PlazaSelectTeamPage,
    // PlazaOverviewPage,
    // PlazaMissionPage,
    // PlazaOverviewCashPage,
    // PlazaOverviewMovementPage,
    // PlazaOverviewPlazamapPage,
    // PlazaSelectPlanPage,
    // PlazaSelectPlanChoosePage,
    PlazaSelectPlanInvestPage,
    PlazaSelectPlanRentPage,
    // PlazaSelectThemePage,
    // PlazaProfitPage,
    // PlazaCashflowPage,
    PlazaStatPage,
    // PlazaSelectThemeSavePage,
    // PlazaScanPayPage,
    // PlazaTicketPage,
    // PlazaTicketSocialPage,
    // PlazaCollectFeePage,
    PlazaCollectFeeConfirmPage,
    // PlazaThemeChangePage,
    // PlazaThemeChangeSavePage,
    PlazaStatMerchantPage,
    PlazaStatShopperPage,
    PlazaStatSubPage,
    // PlazaResultPage,
    PlazaStatMissionPage,
    // MerchantSelectTeamPage,
    // MerchantHomePage,
    // MerchantOverviewPage,
    // MerchantOverviewCashPage,
    // MerchantOverviewMovementPage,
    // MerchantOverviewStockPage,
    // MerchantOverviewPlazaPage,
    // MerchantOverviewPlazamapPage,
    // MerchantMissionPage,
    // MerchantRentalPage,
    // MerchantRentalRentPage,
    // MerchantRentalRentComfirmPage,
    // MerchantRentalYourspacePage,
    // MerchantResultPage,
    MerchantStatShopperPage,
    // MerchantCashflowPage,
    // MerchantProfitPage,
    MerchantStatShopPage,
    // MerchantShopMenuPage,
    // MerchantShopRefillStockPage,
    // MerchantShopPayRentalPage,
    // MerchantShopPayRentalConfirmPage,
    MerchantStatMissionPage,
    // ShopperSelectTeamPage,
    // ShopperBuyProductPlazalistPage,
    ShopperBuyProductPage,
    // ShopperBuyProductPayPage,
    // ShopperBuyProductPayScanPage,
    // ShopperBuyProductPayScanConfirmPage,
    // ShopperBuySocialPlazalistPage,
    // ShopperBuyProductMerchantlistPage,
    // ShopperBuySocialPage,
    // ShopperBuySocialPayPage,
    // ShopperBuySocialPayScanPage,
    // ShopperBuySocialPayScanConfirmPage,
    // ShopperShoppingBagPage,
    ShopperResultPage,
    // ShopperOverviewPage,
    // ShopperOverviewCashPage,
    // ShopperOverviewPlazaPage,
    // ShopperOverviewPlazamapPage,
    // ShopperOverviewMovementPage,
    // ShopperMissionPage,
    // ShopperMissionSocialPage,
    // ShopperMissionSocialDescPage,
    // ShopperMissionShoppingPage,
    // ShopperMissionOutstandingPage,
    // ShopperSocialGroupPage,
    // ShopperSocialGroupCreatePage,
    // ShopperSocialGroupCreateShopPage,
    // ShopperSocialGroupCreateShopNewPage,
    // ShopperSocialGroupJoinPage,
    // ShopperSocialGroupJoinScanPage,
    ShopperSocialGroupJoinInputPage,
    // ShopperSocialGroupJoinScanConfirmPage,
    // ShopperVotePlazaPage,
    // ShopperVotePage,
    // MerchantYourShopPage,
    ViewHeader2Page,
    // ManaulPage,
    // ManaulShopperPage,
    // ManualMerchantPage,
    // LoginQrPage,
    PlazaSlotThemePage,

    ShopperBuyProductPayInputPage,
    ShopperBuySocialPayInputPage,
    MerchantRentalRentInputPage,
    MerchantShopPayRentalInputPage,
    DiscountListPage,
  ],
  providers: [
    StatusBar,
    SplashScreen,
    ServiceProvider,
    QRScanner,
    NativeAudio,
    // StreamingMedia,
    InAppBrowser,
    { provide: ErrorHandler, useClass: IonicErrorHandler },
  ],
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts